<div class="attachments-item">
  <div class="attachments-item__content">
    <div class="attachments-item__title">
      <rt-spinner variant="small" />
      {{ fileData.file.name }}
    </div>
  </div>
</div>
